import Vue from "vue"
import ErrorReporter from "@soenergy/frontend-library/src/services/ErrorReporter"
import { getStore } from "@/plugins/store"

ErrorReporter.init({
  Vue,
  apiKey: "b9f4c1e3ebabf8e03f466165f6ca8fd9",
  appVersion: process.env.version,
  releaseStage: process.env.targetEnv,
  redactedKeys: [
    "password",
    "checkPassword",
    "account_sort_code",
    "bank_account_number",
    "accountNumber",
    "accountSortCode",
    "sortCode",
    "sort_code",
    "token",
    "address",
    "first_name",
    "last_name",
    "email",
    "phone",
    "account_name",
    "first_line_address",
    "second_line_address",
    "billing_address_alt_line1",
    "billing_address_alt_line2",
    "supply_address_alt_line1",
    "supply_address_alt_line2",
    "supply_address_gas_alt_line1",
    "supply_address_gas_alt_line2",
    "bankAccountHolderName",
    "bankAccountNumber",
    "bankAccountSortCode",
    "dateOfBirth",
    "lastName"
  ],
  onError: function(event) {
    const quoteState = getStore().state.quote
    const hasStartedQuoteJourney = !!quoteState.form.postcode
    if (hasStartedQuoteJourney) {
      event.addMetadata("quoteState", quoteState)
    }
  }
})
